export default {
  methods: {
    validate () {
      const [qField] = this.$children
      return qField && typeof qField.validate === 'function'
        ? qField.validate()
        : true
    }
  }
}
